export default "__VITE_ASSET__Ce$yq62g__"